import { truncateString, stringLengthMax } from '../../utils/utilFunctions';

import StyledWrapper from './style';

import Tooltip from '@mui/material/Tooltip';
import SnippetFolderIcon from '@mui/icons-material/SnippetFolder';

import LaunchIcon from '@mui/icons-material/Launch';
import ReviewContent from '../../assets/customIcons/reviewFormIcon';
import ReviewFormIcon from '../../assets/customIcons/reviewForm.jsx';
import AppFormIcon from '../../assets/customIcons/appFormIcon';
import { getStatusColor } from '../../utils/utilFunctions';

const VerticalNavLink = ({
	active,
	text,
	onClick,
	isForm,
	isChild,
	isReview,
	isReviewForm,
	mainLink,
	status,
	external
}) => (
	<StyledWrapper.linkContainer isChild={isChild} active={active}>
		{isForm && !isReviewForm && (
			<AppFormIcon isActive={true} customColor={getStatusColor(status)} />
		)}
		{isForm && isReviewForm && (
			<ReviewFormIcon isActive={true} customColor={getStatusColor(status)} />
		)}
		{isReview && <ReviewContent isActive={true} customColor={getStatusColor(status)} />}
		{!isForm && !isReview && !mainLink && (
			<SnippetFolderIcon
				sx={{ marginRight: '5px' }}
				isActive={true}
				customColor={getStatusColor(status)}
			/>
		)}
		<Tooltip title={text.length > stringLengthMax ? text : ''} arrow placement="top">
			<StyledWrapper.NavLink onClick={onClick} active={active}>
				{truncateString(text)}{' '}
				{external && (
					<LaunchIcon
						viewBox="0 0 24 24 "
						sx={{ position: 'absolute', marginLeft: '2px', transform: 'scale(0.8)' }}
					/>
				)}
			</StyledWrapper.NavLink>
		</Tooltip>
	</StyledWrapper.linkContainer>
);

export default VerticalNavLink;
